import { Base64 } from 'js-base64';

const decodePreview = (previewContent) => {
    const content = JSON.parse(Base64.decode(previewContent));
    return content;
};

export { decodePreview };
